module.exports = __webpack_public_path__ + "img/card-event-02.9b362277.svg";